<script setup lang="ts">
import TagElement from '~/components/tag/element.vue'
import TagGridTemplate from '~/components/tag/gridTemplate.vue'
import VCard from '~/components/ui/VCard.vue'

import { useGetMediaUrl } from '~/composables/useGetMediaUrl'

import { useTagStore } from '~/stores/tag'

import type Tag from '~/entities/tag'

type Props = {
  genreIds: Tag['id'][]
}

const props = defineProps<Props>()

const { getMediaUrl } = useGetMediaUrl()
const { GET_TAGS_FROM_IDS } = useTagStore()

const tags = computed<Tag[]>(() => {
  return GET_TAGS_FROM_IDS(props.genreIds).sort(
    (tagA: Tag, tagB: Tag) =>
      props.genreIds.indexOf(tagA.id) - props.genreIds.indexOf(tagB.id),
  )
})
</script>

<template>
  <VCard v-if="tags.length" class="tw-w-full" padding="5">
    <section>
      <div class="tw-mb-6 tw-flex">
        <img :src="getMediaUrl('gradientHeart.svg')" alt="" class="tw-mr-sm" />
        <h2 class="tw-text-h6">
          {{ $t('influencer.profile.slug.genresAcceptedOften') }}
        </h2>
      </div>
      <TagGridTemplate class="tw-mb-0" padding-class="tw-px-0">
        <TagElement
          v-for="(tag, index) in tags"
          :key="index"
          i18nkey="subgenre"
          :readonly="true"
          :tag="tag"
        />
      </TagGridTemplate>
    </section>
  </VCard>
</template>
